@if (accessibleName) {
  <!-- WCAG 4.1.2: When this loads in a modal, it needs a name as the modal has a "dialog" role. -->
  <p id="screenReaderNameElement" class="sr-only">{{ accessibleName }}</p>
}

@if (!isViewer) {
  <div class="wistia-modal-container">
    <div class="wistia-embed-wrapper">
      @if (showErrorMessage && hasError()) {
        <p class="wistia-error-message" role="alert">
          {{ errorMessage }}
        </p>
      } @else {
        <div id="wistia_{{wistiaCode}}"
          aria-live="assertive"
          class="wistia_embed wistia_async_{{wistiaCode}}">
          &nbsp;
        </div>
      }
    </div>
    <div *ngIf="isModal" class="control-bar">
      <zbp-button-component
        internalId="wistiaModalCloseButton"
        theme="primary"
        (clickHandler)="dismiss()"
        label="Close Video">
      </zbp-button-component>
    </div>
  </div>
} @else {
  <div id="{{wistiaCode}}" class="wistia_embed wistia_async_{{wistiaCode}} autoPlay=true wmode=transparent" [class.fullScreen]="isViewerFullScreen">
    &nbsp;
  </div>
}

